const linkedItemsRequestParamsActions = {
  LINKED_ITEMS_REQUEST_PARAMS_STATE_INIT: 'LINKED_ITEMS_REQUEST_PARAMS_STATE_INIT',
  LINKED_ITEMS_REQUEST_PARAMS_PROP_SET: 'LINKED_ITEMS_REQUEST_PARAMS_PROP_SET',
};
export default linkedItemsRequestParamsActions;
